<template>
<div class="wrap">
    <div class="title">
        <h2 class="dp-inblock">학습자 조회</h2>
        <p class="w-100per">
            - 수강신청을 했던 모든 학습자 조회가 가능합니다.
        </p>
    </div>

    <div class="w-100per mg-auto">
        <table class="admin-table-top table-auto">
            <thead>
                <tr>
                    <th width="200px">이름</th>
                    <td width="*">
                        <input type="text" v-model="params.name" class="w-100per" placeholder="이름을 입력해 주세요">
                    </td>
                    <th class="w-200px">Company</th>
                    <td>
                        <input type="text" v-model="params.companyName" class="w-100per" placeholder="회사명을 입력해 주세요">
                    </td>
                </tr>
                <tr>
                    <th width="200px">사번</th>
                    <td width="*">
                        <input type="text" v-model="params.number" class="w-100per" placeholder="사번을 입력해 주세요">
                    </td>
                    <th class="w-200px">연락처</th>
                    <td>
                        <input type="text" v-model="params.mobile" class="w-100per" placeholder="연락처를 입력해 주세요">
                    </td>
                </tr>
                <tr>
                    <th class="w-200px">E-mail</th>
                    <td colspan="3">
                        <input type="text" v-model="params.email" class="w-100per" placeholder="E-mail을 입력해 주세요">
                    </td>
                </tr>
            </thead>
        </table>
        <div class="mt-10 float-right dp-block"><button class="admin-btn-default w-70px" @click="search()">검색</button></div>
    </div>

    <!-- 검색했을 경우 아래 테이블 노출! -->
    <div class="con w-100per mg-auto">
        <div class="mt-90 dp-block">
            <table class="admin-table-col mt-10 txt-center">
                <thead>
                    <tr>
                        <th width="50px">No</th>
                        <th width="100px">Company</th>
                        <th width="100px">과정명</th>
                        <th width="80px">이름</th>
                        <th width="100px">연락처</th>
                        <th width="100px">E-mail</th>
                        <th width="80px">신청일</th>
                        <th width="80px">결제방법</th>
                        <th width="80px">결제여부</th>
                        <th width="80px">결제금액</th>
                        <th width="80px">상태</th>
                    </tr>
                </thead>
                <tbody v-if="this.isSearched">
                    <tr v-for="(item, index) of userList" :key="index">
                        <td>{{params.totalCount - (params.pageNum - 1) * params.pageSize - index}}</td>
                        <td class="break-all">{{item.company_name}}</td>
                        <td class="break-all">{{item.subject_name}}</td>
                        <td class="pointer txt-blue break-all" @click="openModal('detail', item.idx, item.name, item.mobile, item.idx_itm_sugang_student)" data-toggle="modal" data-target="#student_selet">{{item.name}}</td>
                        <td>{{item.mobile}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.update_date.slice(0, 10) || '-'}}</td>
                        <td>{{formatPayWay(item.pay_way)}}</td>
                        <td>{{formatPayStatus(item.pay_status)}}</td>
                        <td>{{item.price || '-'}}</td>
                        <td>
                            <span class="pointer" @click="openModal('status', item.idx, item.name, item.mobile)" data-toggle="modal" data-target="#student_state" :class="txtColor(item.status)">{{formatStatus(item.status)}}</span>
                            <!-- <span class="">대기완료</span> -->
                        </td>
                    </tr>
                    <!-- 리스트에 내용이 없을 경우 -->
                    <tr v-if="params.totalCount === 0 && this.isSearched">
                        <td colspan="11" class="pt-10 pb-10">등록된 정보가 없습니다.</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td width="100%" colspan="11">조회중입니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="paging mt-30">
        <ul>
            <li>
                <a class="pointer" @click="prevPaging()"> &lt; </a>
            </li>
            <li v-for="index in calcMaxPaging()" :key="index" class="txt-blue">
                <span class="pointer" style="padding: 8px;">
                    <a @click="paging(index)" :class="{'carrot-active bold': index === pageNum}">{{index}}</a>
                </span>
            </li>
            <li>
                <a class="pointer" @click="nextPaging()"> &gt; </a>
            </li>
        </ul>
    </div>
    <detail-modal v-if="isDetailModalOpened" :parentIdx="idxItmSugangSubject" :idxItmSugangStudent="idxItmSugangStudent" :parentName="parentName" @close="closeModal"></detail-modal>
    <status-modal v-if="isStatusModalOpened" :parentSData="parentSData" @close="closeModal" @refresh="refresh()"></status-modal>
</div>
</template>

<script>
import DetailModal from '@/components/search/detailModal.vue'
import StatusModal from '@/components/search/statusModal.vue'
export default {
    components: {
        DetailModal,
        StatusModal
    },
    data: () => ({
        isSearched: false,
        userList: [],
        isDetailModalOpened: false, // 신청내역 상세 모달 오픈 여부
        isStatusModalOpened: false, // 상태 변경 모달 오픈 여부

        parentSData: {}, // 상태변경 팝업에 전달할 데이터
        parentName: '', // 신청정보 상세보기 팝업에 전달할 이름

        idxItmSugangSubject: '', // 수강신청 과목 idx
        idxItmSugangStudent: '', // 수강신청 학생 idx
        
        params: {
            companyName: '',
            email: '',
            mobile: '',
            name: '',
            number: '',
            pageNum: 1,
            pageSize: 20,
            maxPagingCount: 1,
            maxPagePart: 1,
            pagePart: 1,
            totalCount: 0,
        }
    }),

    mounted() {
        this.search()
    },

    methods: {
        // 페이징
        paging(page) {
            this.params.pageNum = page
            this.search()
        },

        // 이전 페이징
        prevPaging() {
            if (this.params.pageNum === 1) {
                return false
            } else {
                this.params.pageNum -= 1
                this.search()
            }
        },

        // 다음 페이징
        nextPaging() {
            if (this.params.pageNum === this.params.maxPagingCount) {
                return false
            } else {
                this.params.pageNum += 1
                this.search()
            }
        },

        // 현재 페이지의 페이지 범위 계산
        calcMaxPaging() {
            if (this.params.maxPagingCount > this.params.pagePart * 10) {
                this.params.maxPagePart = this.params.pagePart * 10
            } else {
                this.params.maxPagePart = this.params.maxPagingCount
            }
            var pagingArray = []
            for (var i = ((this.params.pagePart - 1) * 10) + 1; i <= this.params.maxPagePart; i++) {
                pagingArray.push(i)
            }
            return pagingArray
        },

        txtColor (status) {
            switch (status) {
                case 'Y':
                    return 'txt-green'
                case 'N':
                    return ''
                case 'C':
                    return 'txt-red'
                default:
                    return ''
            }
        },
        // 레이어팝업으로 상태 변경시 리스트 api 재 호출 
        refresh () {
            this.search()
        },
        // payStatus에 따른 한글 변환
        formatPayStatus(status) {
            switch (status) {
                case 'Y':
                    return '결제완료'
                case 'N':
                    return '미결제'
                case 'X':
                    return '결제없음'
                case 'C':
                    return '결제취소'
                case 'P':
                    return '결제취소대기'
                default:
                    return '-'
            }
        },

        // status에 따른 한글 변환
        formatStatus(status) {
            switch (status) {
                case 'Y':
                    return '대기'
                case 'N':
                    return '신청완료'
                case 'C':
                    return '신청취소'
                default:
                    return '-'
            }
        },
        // 결제방법에 따른 한글 변환
        formatPayWay(status) {
            switch (status) {
                case 'C':
                    return '카드'
                case 'A':
                    return '계좌이체'
                default:
                    return '-'
            }
        },
        // 검색 api 호출
        search() {
            this.isSearched = false

            console.log('params', this.params)
            this.axios.get(this.axios.root + this.axios.port + '/admin/student-list', {
                params: this.params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.userList = res.data.userList
                    this.params.totalCount = res.data.totalCount
                    this.params.maxPagingCount = Math.ceil(this.params.totalCount / this.params.pageSize)
                    this.params.maxPagePart = Math.ceil(this.params.maxPagingCount / 10)
                    this.params.pagePart = Math.ceil(this.params.pageNum / 10)
                    this.isSearched = true
                } else {
                    alert(res.data.result)
                    this.userList = []
                    this.params.totalCount = 0
                }
            })
        },

        // 검색 모달 열기
        openModal(type, idx, name, mobile, idxItmSugangStudent) {
            if (type === 'detail') {
                this.idxItmSugangSubject = idx
                this.idxItmSugangStudent = idxItmSugangStudent
                this.parentName = name
                this.isDetailModalOpened = true
            } else if (type === 'status') {
                this.parentSData = {
                    studentSubjectIdx: idx,
                    name: name,
                    mobile: mobile
                }
                
                this.isStatusModalOpened = true
            }
        },

        // 검색 모달 닫기
        closeModal() {
            if (this.isDetailModalOpened) {
                this.isDetailModalOpened = false
            } else if (this.isStatusModalOpened) {
                this.isStatusModalOpened = false
            }
        }
    }
}
</script>
